// extracted by mini-css-extract-plugin
export var bounce = "_l4-1";
export var generatingText = "_l4-6";
export var lightning = "_l4-4";
export var popup = "_l4-5";
export var progressBar = "_l4-7";
export var progressFill = "_l4-8";
export var progressShimmer = "_l4-9";
export var progressText = "_l4-a";
export var shimmer = "_l4-3";
export var uploadIcon = "_l4-0";
export var uploadingText = "_l4-2";